import Vue from 'vue';
import moment from 'moment';
import App from './App.vue';
import router from './router';
import store from './store';
import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
import './assets/icons.scss';
import '@/assets/site.scss';
import helper, { _loadComponent } from './services/helper';
import { i18n, loadLanguageAsync, locales } from './i18n-setup';
import api from './services/api';
import { _encrypt } from './services/encryption';
//import 'bootstrap-v4-rtl/dist/js/bootstrap.min.js';

import VueRecaptcha from 'vue-recaptcha';
import VModal from 'vue-js-modal';
import VueJsModalWrapper from '@/components/VueJsModalWrapper.vue';
import LocalesSwitcher from '@/components/LocalesSwitcher.vue';
import $ from 'jquery';
import '@/assets/accessibility/css/accessibilityMenu.css';
import '@/assets/accessibility/accessibilityMenu.js';
import '@/assets/accessibility/accessibility-ru.js';
import '@/assets/accessibility/accessibility-he.js';
import '@/assets/accessibility/accessibility-en.js';

Vue.config.productionTip = false;

Vue.use(VModal);
Vue.component('vue-recaptcha', VueRecaptcha);
Vue.component('modal-base', VueJsModalWrapper);

Vue.component('Navigation', (resolve) => _loadComponent('Navigation/', resolve));
Vue.component('LocalesSwitcher', LocalesSwitcher);

Vue.filter('splitLines', function(value: any, tag = 'div') {
  var startTag = `<${tag}>`;
  var endTag = `</${tag}>`;
  return String(value)
    .split('\n')
    .map((x) => startTag + (x || ' ') + endTag)
    .join('');
});

Vue.filter('moment', (date: Date, format: string = 'DD/MM/YYYY HH:mm:ss') => {
  return date ? moment(date).format(format) : '';
});
Vue.filter('momentutc', (date: Date, format: string = 'DD/MM/YYYY HH:mm:ss') => {
  return date
    ? moment
        .utc(date)
        .local()
        .format(format)
    : '';
});
Vue.filter('momentchat', (date: Date, format: string = 'DD/MM/YYYY HH:mm:ss') => {
  if (!date) return '';
  let d = moment.utc(date).local();
  return moment().isSame(d, 'day') ? d.format('HH:mm:ss') : d.format('DD/MM/YYYY HH:mm:ss');
});

(async () => {
  helper.swalShowLoading();
  const initResult = await api.Init();
  const config = await initResult.getData(true);
  if (!config) {
    window.location.reload();
    return;
  }
  store.commit('Init', config);

  let lang = config.Lang;
  await loadLanguageAsync(lang);
  setDir(lang);
  helper.close();

  let locale = '';
  switch (lang) {
    case 'ru-RU':
      locale = 'ru';
      break;
    case 'en-US':
      locale = 'en';
      break;
    case 'he-IL':
      locale = 'he';
      break;
    default:
      locale = 'en';
      break;
  }
  
  ($ as any).accessibility.setDefaults(($ as any).accessibility.language[locale]);
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
})();

function setDir(lang: string) {
  var loc = locales.find((x) => x.name == lang);

  const dir = loc!.dir;
  const lng = loc!.twoLetter;
  let body = document.querySelector('body');
  let html = document.querySelector('html');
  if (body && html) {
    body.className = dir;
    /*
    $(body)
      .removeClass(['rtl', 'ltr'])
      .addClass(dir);
      */
    body.setAttribute('dir', dir);
    html.setAttribute('lang', lng);
  }
}
